import { withDependencies } from '@wix/thunderbolt-ioc'
import { IAppWillLoadPageHandler, PlatformSymbol, PlatformDsApi } from '@wix/thunderbolt-symbols'

export const PlatformAppWillLoadPage = withDependencies(
	[PlatformSymbol],
	(platformDsApi: PlatformDsApi): IAppWillLoadPageHandler => {
		return {
			name: 'platformAppWillLoadPage',
			async appWillLoadPage(pageInfo) {
				await platformDsApi.runPlatform({ pageInfo })
			},
		}
	}
)
